<div class="fix-width bg-white flex column radius padding margin-top-largest shadow">
  <div class="flex center margin-bottom">
    <img src="https://basicplatformblob.blob.core.windows.net/resources/LOGOS/BASICNET.PNG" />
  </div>

  <div class="margin-bottom-small">
    Please select your
    <b>Company</b>
    :
  </div>

  <div class="flex column margin-top-smallest">
    <div class="flex column scrollable border bg-light-grey company-list-box">
      @if (companyFilterService.loading && !datasource.length) {
        <div class="flex center padding">
          <i class="fa-solid fa-circle-notch fa-spin"></i>
        </div>
      } @else {
        @for (company of datasource; track company.displayId) {
          <div
            class="padding-small hover"
            [ngClass]="company.selected ? 'bg-primary white' : ''"
            (click)="onClickCompany(company)"
          >
            <i class="fa fa-arrow-right margin-right-smallest"></i>
            {{ company.displayName }}
          </div>
        }
      }
    </div>
  </div>

  <div class="flex column end margin-top">
    <button (click)="companySelection()" [disabled]="!selectedCompany.length">
      <i class="fa fa-check margin-right-small"></i>
      Confirm
    </button>
  </div>
</div>
